// Copyright (c) 2016 Deere & Company

import TimestampUser from '../state/timestamp-user';
import actions from '../../../../sharedmodules/actions-list';
import { createNewTransfer } from '../../shared/repositories';
import { createSuccessMessage } from '../../../../sharedmodules/action-creators/alert-messages';
import { handleError } from '../../../../sharedmodules/services/error-handlers';
import moment from 'moment';
import { translate } from '../../../../sharedmodules/services/translation-service';

export const createTransfer = (getAccessToken) => async (dispatch, getState) => {

    try {

        dispatch({
            type: actions.INCREASE_BUSY_COUNTER,
        });

        const userDetails = getState().oktaState.oktaState.userName.split(/(\s+)/);

        const createTransferData = {
            currentDealer: getState().application.createTransfer.product.dealer,
            id: '0',
            newDealer: getState().application.createTransfer.newTransfer.newDealer,
            product: getState().application.createTransfer.product,
            reasonForChange: getState().application.createTransfer.newTransfer.reasonForChange,
            requestDate: moment.utc().startOf('day').valueOf(),
            requestedBy: new TimestampUser({
                firstName: userDetails.length >= 3 ? userDetails[2] : '',
                id: getState().oktaState.oktaState.userId.toUpperCase(),
                lastName: userDetails.length >= 3 ? userDetails[0] : '',
            }),
            status: 'ACCEPTED',
        };

        const createTransferResponse = await createNewTransfer(getAccessToken, createTransferData);

        dispatch({
            data: createTransferResponse,
            type: actions.CREATE_NEW_TRANSFER_SUCCESS,
        });

        dispatch({
            type: actions.RESET_NEW_TRANSFER,
        });

        dispatch({ type: actions.RESET_PIN_SEARCH_DATA });

        dispatch(createSuccessMessage(translate('TRANSFER_CREATED')));

    } catch (error) {

        handleError(error);

    } finally {

        dispatch({ type: actions.DECREASE_BUSY_COUNTER });

    }

};
